import { withJsonFormsControlProps } from '@jsonforms/react'
import { componentTester, ComponentDisplay } from '../component/Component'

export const componentDisplay = {
  tester: componentTester,
  renderer: withJsonFormsControlProps(ComponentDisplay),
}

export const componentDisplayRenderer = {
  component: {
    tester: componentTester,
    renderer: withJsonFormsControlProps(ComponentDisplay),
  },
}
